import { defineStore } from 'pinia';
import { ref } from 'vue';

import workerService from '@/modules/worker/services/workerService';

const REGISTRATIONS_COUNT_INTERVAL_MS = 5 * 60 * 1000;

export const useRegistrationsStore = defineStore('registrations', () => {
	const count = ref(0);
	let pollingInterval: ReturnType<typeof setInterval> | undefined;

	const fetchCount = async () => {
		try {
			const response = await workerService.getRegistrationsCount();
			count.value = response.count;
		} catch {
			count.value = 0;
		}
	};

	const startPolling = () => {
		stopPolling();
		fetchCount();
		pollingInterval = setInterval(fetchCount, REGISTRATIONS_COUNT_INTERVAL_MS);
	};

	const stopPolling = () => {
		if (pollingInterval) {
			clearInterval(pollingInterval);
			pollingInterval = undefined;
		}
	};

	const decrementCount = () => {
		count.value = Math.max(0, count.value - 1);
	};

	// Optimistic: the query-side projection lags behind the command, an immediate
	// refetch would read the pre-add count (same pattern as decrementCount)
	const incrementCount = () => {
		count.value = count.value + 1;
	};

	return {
		count,
		fetchCount,
		decrementCount,
		incrementCount,
		startPolling,
		stopPolling,
	};
});
